import Immutable from 'immutable';

const Attachment = Immutable.Record({
  id: '',
  type: '',
  name: '',
  contentType: '',
  contentLength: '',
  preview: '',
  url: '',
});

export default Attachment;
